import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { Assessment } from '../../models/AssessmentModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';

@Component({
  selector: 'cw-ci-admin-assessment-list',
  templateUrl: './assessment-list.component.html',
  styleUrls: []
})
export class AdminAssessmentListComponent implements OnInit {

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) assessmentTemplateDataTable: DataTableComponent;
  assessmentTemplateList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: Assessment) {
    return true;
  }

  addAssessmentTemplate(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editAssessmentTemplate(item: Assessment) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  deleteAssessmentTemplate(item: Assessment) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: ['Are you sure you want to permanently delete this assessment template?'],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this.assessmentTemplateDataTable.showProcessing('Deleting assessment template...');

        this._platformApi.deleteAssessmentTemplate(item.id).subscribe(
          resp => {
            this.assessmentTemplateDataTable.executeLoadItems();
          }
        );
      }
    });
  }

  loadAssessmentTemplates(filter = new ResultFilter()) {
    this.assessmentTemplateDataTable.showProcessing();
    const listObservable = this._platformApi.getAssessments(filter);
    listObservable.subscribe(results => {
      this.assessmentTemplateList = results;
    })
  }
}
